export default __webpack_public_path__ + "static/media/fitingovaya_platforma.0c5cde5e.svg";